// Narrower than "any non-modifier key" so app shortcuts, Escape and Enter don't bring back rings after a click
const FOCUS_MOVING_KEYS = new Set([
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
]);

// Safari uses Option+Tab to move focus between controls.
export const isFocusMovingKey = (event: KeyboardEvent) =>
  FOCUS_MOVING_KEYS.has(event.key) && !event.metaKey && !event.ctrlKey && (!event.altKey || event.key === "Tab");

const setInputModality = (modality: "pointer" | "keyboard") => {
  document.documentElement.dataset.inputModality = modality;
};

const registerInputModalityListeners = () => {
  window.addEventListener("pointerdown", () => setInputModality("pointer"), { capture: true, passive: true });
  window.addEventListener(
    "keydown",
    (event) => {
      if (isFocusMovingKey(event)) {
        setInputModality("keyboard");
      }
    },
    { capture: true, passive: true }
  );
};

export default registerInputModalityListeners;
